import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/ListingRules.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/configurations/listings/rules`;
	}
	async list(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}`, e));
	}
};
//#endregion
export { n as ListingRules };

//# sourceMappingURL=ListingRules.js.map